/* src/app/home/cancel-modal/cancel-modal.component.scss */
.modal-header {
  border-bottom: none;
}
.modal-footer {
  border-top: none;
  justify-content: center;
  flex-direction: column;
  gap: 4px;
}
.modal-footer .buttons {
  display: flex;
  gap: 8px;
}
p {
  line-height: 13px;
}
textarea {
  resize: none;
  width: 100%;
  border-radius: 0;
  min-height: 70px;
}
.cancel {
  padding: 10px;
  max-width: 900px;
  width: 100%;
}
.btn-green {
  color: white;
  background-color: #00857D;
  border-radius: 35px;
  width: 97px;
  height: 36px;
}
.btn-white {
  color: #00857D;
  background-color: white;
  border-radius: 35px;
  border: thin #00857D solid;
  width: 97px;
  height: 36px;
}
.error {
  color: red;
}
.t-error::placeholder {
  color: red;
  font-size: 1.5em;
  text-align: right;
  font-weight: bold;
}
.t-error {
  border-color: red;
}
/*# sourceMappingURL=cancel-modal.component.css.map */
